import React from 'react';
import  AppNavigation from './navigation';
import HttpLoader from './containers/http-loader';

import './App.less';

function App() {
    return (
        <>
            <HttpLoader />
            <AppNavigation/>
        </>
    );
}

export default App;
    